"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversationChannels = void 0;
var env_1 = require("../../env");
exports.conversationChannels = {
  id: 'conversation-channels',
  label: 'Conversation Channels',
  icon: function (_a) {
    var icons = _a.icons;
    return icons.AppSections.Conversations;
  },
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:conversation-channels'] : null,
  children: [{
    id: 'conversation-channels',
    type: 'conversation-channels'
  }]
};